<div class="toolbar">
  <p-button label="Nueva entidad" icon="pi pi-plus" (click)="newRecord()"></p-button>
  <p-button label="Eliminar seleccionados" severity="danger" (click)="deleteSelected()" *ngIf="selectedRecords?.length"></p-button>
</div>

<p-table [value]="records$ | async" styleClass="p-datatable-striped" sortMode="single"
  [(selection)]="selectedRecords" dataKey="id">
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="title" id="title-column">Título <p-sortIcon field="title"></p-sortIcon></th>
      <th pSortableColumn="createdAt" id="createdAt-column">Creado <p-sortIcon field="createdAt"></p-sortIcon></th>
      <th pSortableColumn="updatedAt" id="updatedAt-column">Actualizado <p-sortIcon field="updatedAt"></p-sortIcon></th>
      <th pSortableColumn="totalFields" id="totalFields-column">Total campos <p-sortIcon field="totalFields"></p-sortIcon></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-record>
    <tr [pSelectableRow]="record">
      <td>
        <div class="row-buttons">
          <p-tableCheckbox [value]="record"></p-tableCheckbox>
          <button pButton pRipple type="button" icon="pi pi-pencil" (click)="onRowEdit(record)"
            class="p-button-rounded p-button-text"></button>
        </div>
      </td>
      <td>{{ record.title }}</td>
      <td>{{ record.createdAt | date: 'dd MMM yyyy, HH:mm' }}</td>
      <td>{{ record.updatedAt | date: 'dd MMM yyyy, HH:mm' }}</td>
      <td>{{ record.totalFields }}</td>
    </tr>
  </ng-template>
</p-table>
